import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDeleteCategoryRequest,
  fetchListCategoryRequest,
} from "redux/ActionCreators/CategoryActionCreators";

const columns = [
  { id: "name", label: "Tên", minWidth: 170 },
  { id: "code", label: "Ảnh", minWidth: 100 },
  {
    id: "density",
    label: "Action",
    minWidth: 170,
    align: "center",
    format: (value) => value.toFixed(2),
  },
];

function CategoryTable(props) {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.categories.list);

  useEffect(() => {
    dispatch(fetchListCategoryRequest());
  }, []);

  const handleDeleteProduct = (id) => {
    dispatch(fetchDeleteCategoryRequest(id));
    dispatch(fetchListCategoryRequest());
  };

  return (
    <Paper>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {categories &&
              categories.map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    <TableCell>{row.id}</TableCell>

                    <TableCell align="center">{row.name}</TableCell>

                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ width: "100px" }}
                      >
                        Sửa
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        style={{ width: "100px", float: "right" }}
                        onClick={() => handleDeleteProduct(row.id)}
                      >
                        Xóa
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

CategoryTable.propTypes = {};

export default CategoryTable;
